import { ProjectWizard } from "@/components/project-wizard/wizard";

export function ProjectNewPage() {
  return <ProjectWizard />;
}
